import { useLocation } from 'react-router-dom'

import { Loader } from '@paysense-india-services/elevate-web'

import { ROUTES } from '@/constants/routes'

import { AuthContext } from '@/contexts/AuthContext'

import { useAuth } from '@/hooks/useAuth'

import SplitLayout from '@/components/SplitLayout'

function normalizePath(path) {
  if (!path || path === '/') return '/'
  const p = path.replace(/\/+$/, '') || '/'
  return p === '/' ? '/' : `${p}/`
}

function isLoginOrOtpPath(pathname) {
  const n = normalizePath(pathname)
  return n === ROUTES.LOGIN || n === ROUTES.OTP
}

export default function AuthLayout({ children }) {
  const { isAuthenticated, loading, ...rest } = useAuth()
  const location = useLocation()
  const pathname = location.pathname

  if (loading) {
    return <Loader color='brand' loadingText='Please Wait...' pageLoader size='large' />
  }

  if (!isAuthenticated && !isLoginOrOtpPath(pathname)) {
    return (
      <div className='ew-d-flex ew-h-100 ew-align-items-center ew-justify-content-center'>
        Redirecting to login page...
      </div>
    )
  }

  return (
    <AuthContext.Provider value={{ isUserLoggedIn: isAuthenticated, ...rest }}>
      {isLoginOrOtpPath(pathname) ? <SplitLayout>{children}</SplitLayout> : children}
    </AuthContext.Provider>
  )
}
